import type {
  CreateUserInviteRequest,
  CreateUserInviteResponse,
} from '../types/UserInviteTypes'
import AuthAxios from '@/lib/api/axios/AuthAxios'

/**
 * Creates and sends a new user invitation to join a workspace
 * @param workspaceSlug - The workspace slug (environment)
 * @param request - Invitation details (email, role, message, expiration)
 * @returns Created invitation details with ID and expiration timestamp
 * @throws Error if invitation fails (duplicate, invalid email, etc.)
 */
export async function createInvite(
  workspaceSlug: string,
  request: CreateUserInviteRequest,
): Promise<CreateUserInviteResponse> {
  const response = await AuthAxios.post<CreateUserInviteResponse>(
    `/api/v1.0/e/${workspaceSlug}/invites`,
    request,
  )

  return response.data
}
